import Ajax from '../../modules/ajax/ajax';
import Component from '../component/component';
import Helpers from '../helpers/helpers';

import './subscribe.scss';

export default class Subscribe extends Component {

    public static initSelector: string = '.subscribe';

    public form: JQuery;
    public success: JQuery;
    public emailInput: JQuery;
    public emailField: JQuery;

    public isSubmitted: boolean = false;

    constructor(element: HTMLElement) {
        super(element);

        this.form = this.element.find('form.subscribe__form');
        this.success = this.element.find('.subscribe__success');
        this.emailInput = this.element.find('[name="email"]');
        this.emailField = this.emailInput.parents('.textfield');
        this.form.on('submit', this.onSubmit.bind(this));
    }

    onSubmit(event: JQuery.SubmitEvent): void {
        event.preventDefault();

        if (!this.isSubmitted) {
            this.isSubmitted = true;
            const email: string = `${this.emailInput.val()}`;

            Ajax
                .post({
                    action: 'subscribe',
                    email,
                    isGreenTheme: window.gotoAndPlay.isGreenTheme,
                    isLightBlueTheme: window.gotoAndPlay.isLightBlueTheme,
                })
                .then((response: { success: boolean, error: string }) => {
                    if (response.success) {
                        Helpers.trackEvent({
                            action: 'form',
                            category: 'Liitu uudiskirjaga',
                        });

                        this.form.remove();
                        this.success.removeClass('h-hidden');
                        this.element.addClass('is-success');
                    } else {
                        this.isSubmitted = false;
                        this.emailField.addClass('is-invalid');
                        this.emailField.find('.textfield__error').text(response.error);
                    }
                })
                .catch(() => {
                    this.emailField.addClass('is-invalid');
                });
        }
    }

}
